/**
 * Controller for the story drawer
 * @author Denis Sobolev, Ryan Gladstone, Umer Hassan
 */

function StoryDrawerController(
  $scope,
  $log,
  _,
  featureFlag,
  storyDrawerService,
  story,
  tab,
  data,
  hidePanel,
  Story
) {
  $scope.init = async () => {
    $scope.socialEnabled = await featureFlag.isEnabled('arcSocial');
  };

  $scope.init();
  $scope.hidePanel = hidePanel;
  $scope.detailedView = true;

  const storyConfig = {};
  const storyPitch = story.websked.pitch;

  if (storyPitch && storyPitch.type === 'platform') {
    storyConfig.platform = storyPitch.planPath;
  } else if (storyPitch && storyPitch.type === 'publication') {
    storyConfig.publication = storyPitch.publicationId;
  }

  Story.get(story.id, storyConfig)
    .then(
      (dataParam) => {
        $scope.story = dataParam;
        $scope.storyLink = encodeURIComponent(dataParam.id);
        $scope.story.formattedDates = dataParam.getFormattedDates($scope.story);
        $scope.loaded = true;
        $scope.pitchesForPanel = {
          platforms: $scope.story.pitches,
          publications: $scope.story.publicationPitches
        };
      },
      error => $log.error(error)
    );

  $scope.tabs = {
    preview: {},
    pitches: {},
    tasks: {},
    metadata: {}
  };

  $scope.story = story;
  $scope.tab = tab;

  if (data) {
    $scope.task = data.task;
  }

  $scope.dismiss = () => {
    storyDrawerService.dismiss($scope.story);
  };

  $scope.setCollections = (collections) => {
    $scope.story.collections = collections;
  };

  /**
   * This is a work around when clicked on the backdrop,
   * passing in the story instead of the default string
   */
  $scope.$on('modal.closing', (event, dataParam) => {
    if (dataParam === 'backdrop click') {
      event.preventDefault();
      storyDrawerService.dismiss($scope.story);
    }
  });
}

const arr = [
  '$scope',
  '$log',
  '_',
  'featureFlag',
  'storyDrawerService',
  'story',
  'tab',
  'data',
  'hidePanel',
  'Story',
  StoryDrawerController
];

export default function (ngModule) {
  ngModule.controller('StoryDrawerController', arr);
}
